export enum EffectBase {
  /// <summary>
  /// بدون مبنا
  /// </summary>
  WithoutBase = 1,
  /// <summary>
  /// کارکرد استاندارد
  /// </summary>
  StandardWork = 2,
  /// <summary>
  /// کارکرد تقویمی
  /// </summary>
  CalendarWork = 3,
  /// <summary>
  /// کارکرد ثابت
  /// </summary>
  FixedWork = 4,
}
